import {createContext} from 'react'

const CatTipoVentaContext = createContext()

export default CatTipoVentaContext